import { Link, Typography } from "@mui/material";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import * as React from "react";

export const LSResultItemTitle = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  if (!resource) {
    return null;
  }

  return (
    <Typography component="h3" variant="h6" flex={1}>
      <Link href={`#section=resource&resourceId=${resource.id}`}>
        {resource.shortTitle}
      </Link>{" "}
      {resource?.publicationDate?.publicationDate && (
        <span>({resource?.publicationDate?.publicationDate})</span>
      )}
    </Typography>
  );
};
